// extracted by mini-css-extract-plugin
export var carrierTab = "_40-0";
export var carrierTabActive = "_40-1 _40-0";
export var carrierTabInactive = "_40-2 _40-0";
export var carrierTabLabel = "_40-3";
export var carrierTabLabelActive = "_40-4 _40-3";
export var carrierTabLabelInactive = "_40-5 _40-3";
export var carrierTabPercentage = "_40-6";
export var carrierTabPercentageActive = "_40-7 _40-6";
export var carrierTabPercentageInactive = "_40-8 _40-6";
export var carrierTabWinnable = "_40-9";
export var carrierTabWinnableActive = "_40-a _40-9";
export var carrierTabWinnableInactive = "_40-b _40-9";
export var comparisonContainer = "_40-d";
export var missingRateButton = "_40-n";
export var missingRateButtonActive = "_40-o _40-n";
export var missingRateButtonInactive = "_40-p _40-n";
export var missingRateButtonLabel = "_40-q";
export var missingRateButtonLabelActive = "_40-r _40-q";
export var missingRateButtonLabelInactive = "_40-s _40-q";
export var sidebar = "_40-c";
export var strategyButton = "_40-e";
export var strategyButtonActive = "_40-f _40-e";
export var strategyButtonDescription = "_40-k";
export var strategyButtonDescriptionActive = "_40-l _40-k";
export var strategyButtonDescriptionInactive = "_40-m _40-k";
export var strategyButtonInactive = "_40-g _40-e";
export var strategyButtonLabel = "_40-h";
export var strategyButtonLabelActive = "_40-i _40-h";
export var strategyButtonLabelInactive = "_40-j _40-h";
export var unitToggleButton = "_40-t";
export var unitToggleButtonActive = "_40-u _40-t";
export var unitToggleButtonInactive = "_40-v _40-t";
export var unitToggleButtonLabel = "_40-w";
export var unitToggleButtonLabelActive = "_40-x _40-w";
export var unitToggleButtonLabelInactive = "_40-y _40-w";